<template>
  <v-dialog
    v-model="getValue"
    content-class="sidebarDialog"
    hide-overlay
  >
    <v-layout
      row
      align-center
      justify-space-between
      ma-4
    >
      <v-flex>
        <h4>
          {{ title }}
        </h4>
      </v-flex>
      <v-flex
        xs1
      >
        <v-icon
          @click="getValue = false"
        >
          mdi-close
        </v-icon>
      </v-flex>
    </v-layout>
    <v-divider class="pa-0 ma-0" />
    <v-container
      fluid
      grid-list-sm
    >
      <v-layout
        style="height: calc(100% - 130px);"
      >
        <v-flex>
          <slot />
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: 'SidebarDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

};
</script>
<style lang="stylus" scoped>
  h4
    font-family: Open Sans
    font-style: normal
    font-weight: normal
    font-size: 20px
    line-height: 29px
    color: #757575
</style>
